import ActionTypes from '../constants/actionTypes'
import formatDate from '../utils/formatDate'

const initialState = {
  date: formatDate(new Date()), // yyyy-mm
  reminders: {},
  showModal: false,
  editingReminder: null,
}

function calendar(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.CHANGE_DATE: {
      return {
        ...state,
        date: action.payload,
      }
    }

    case ActionTypes.TOGGLE_MODAL: {
      return {
        ...state,
        showModal: action.payload,
        editingReminder: action.payload ? state.editingReminder : null,
      }
    }

    case ActionTypes.ADD_REMINDER: {
      const { shouldDeleteDate } = action.payload
      const reminder = action.payload.reminder
      const key = reminder.date
      let newState = state
      if (shouldDeleteDate) {
        // We are using this action to edit reminders, and we may want to delete when editing the event date
        newState = deleteHelper(state, shouldDeleteDate, reminder.id)
      }
      return {
        ...newState,
        editingReminder: false,
        reminders: {
          ...newState.reminders,
          [key]: {
            ...newState.reminders[key],
            [reminder.id]: reminder,
          },
        },
      }
    }

    case ActionTypes.EDITING_REMINDER: {
      return {
        ...state,
        editingReminder: action.payload,
        showModal: true,
      }
    }

    case ActionTypes.DELETE_REMINDER: {
      const reminder = action.payload
      return {
        ...state,
        ...deleteHelper(state, reminder.date, reminder.id),
        showModal: false,
        editingReminder: false,
      }
    }

    default:
      return state
  }
}

function deleteHelper(state, date, id) {
  const newState = state
  const dateObjReminder = newState.reminders[date]
  delete dateObjReminder[id]
  if (!Object.keys(dateObjReminder).length) {
    delete newState.reminders[date]
    return newState
  }
  return {
    ...newState,
    reminders: {
      ...newState.reminders,
      [date]: dateObjReminder,
    },
  }
}

export default calendar
